export default __webpack_public_path__ + "static/media/robot-icon-black-small.2bbe902b.svg";